export default (id) => app.timer.start(id);
